export default __webpack_public_path__ + "static/media/joe-gardner-2-edit.659a831e.jpg";